/**
 * 企业对账单
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Button, message } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/enterprisereconciliation/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TabType } from '../../types';
import { TableActionType as ta } from '@/util/enum';
import ReconciliationModal from '../modal/ReconciliationModal';

class Main extends React.Component {

    state = {
        enterpriseName: undefined,
        status: {},
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        openModeParam: {},
        currentOpenMode: '',
        generating: false
    }

    componentDidMount() {
        this.props.getStateList();
    }

    // 查询
    _searchHandle = (useCache) => {
        const { enterpriseName, status, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            targetName: enterpriseName,
            verifyStatus: status.name,
            startDate: startTime && startTime.split(' ')[0],
            endDate: endTime && endTime.split(' ')[0],
            type: 'ENTERPRISE',

            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getReconciliationList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ enterpriseName: undefined, status: {}, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 生成报表
    _generateReport = () => {
        this.setState({ generating: true });
        let templateId = 41;
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportTemplateService.info', { id: templateId }).then(res => {
            const { enterpriseName, status, startTime, endTime } = this.state;
            const conds = {
                targetName: enterpriseName,
                verifyStatus: status.name && { code: status.name, value: status.value },
                startDate: startTime && startTime.split(' ')[0],
                endDate: endTime && endTime.split(' ')[0],
                type: 'ENTERPRISE',
            };
            const queryCriteriaList = res.result.queryCriteriaList || [];
            queryCriteriaList.forEach(r => r.value = conds[r.conditionFiled]);

            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.report.ReportRecordService.addReportRecord', {
                templateId,
                queryCriteriaList,
                purpose: '企业对账单'
            }).then(res => {
                message.success('生成报表成功');
                this.setState({ generating: false });
            }).catch((res = {}) => {
                message.error(res.message || '生成报表异常')
                this.setState({ generating: false });

            });
        }).catch((res = {}) => {
            this.setState({ generating: false });
            message.error(res.message || '获取模板数据异常');
        });
    }

    // 生成对账单
    _newReconciliation = () => {
        this.setState({ currentOpenMode: ta.sure, openModeParam: {} });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history, curTabID } = this.props;
        switch (type) {
            case ta.detail:
                sessionStorage.setItem('enterprisereconciliation', curTabID);
                history.push({ pathname: `/home/finance/enterprisereconciliation/reconciliation/detail/${key}` });
                break;
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case ta.sure:
                return <ReconciliationModal title='生成对账单' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    render() {
        const { enterpriseName, status, startTime, endTime, generating } = this.state;
        let { curTabID, reconciliationList, stateList } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='企业名称'
                                placeholder='请输入'
                                value={enterpriseName}
                                bindThis={this}
                                bindName='enterpriseName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: 150 }}
                                label='状态'
                                placeholder='请选择'
                                renderData={stateList}
                                dataIndex='value'
                                keyIndex='name'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='对账周期'
                                datePickerStyle={{ width: 150 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                showTime={false}
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 150 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.row2}>
                        <Button
                            type='primary'
                            onClick={this._generateReport}
                            loading={generating}
                            style={{ width: 100, marginRight: 10, borderRadius: 4 }}
                        >生成报表</Button>
                        <Button
                            type='primary'
                            onClick={this._newReconciliation}
                            style={{ width: 100, marginRight: 10, borderRadius: 4 }}
                        >生成对账单</Button>
                    </div>
                    <TableList
                        renderData={reconciliationList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,
    getReconciliationList: PropTypes.func,
    reconciliationList: PropTypes.object,

    getStateList: PropTypes.func,
    stateList: PropTypes.array
};
const mapStateToProps = (state) => ({
    stateList: state.enterprisereconciliation.stateList,
    reconciliationList: state.enterprisereconciliation.reconciliationList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);